import { render, staticRenderFns } from "./privacyQd.vue?vue&type=template&id=79c39244&scoped=true&"
import script from "./privacyQd.vue?vue&type=script&lang=js&"
export * from "./privacyQd.vue?vue&type=script&lang=js&"
import style0 from "./privacyQd.vue?vue&type=style&index=0&id=79c39244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c39244",
  null
  
)

export default component.exports